import type {DataRouterDeletePagePayload} from '@github-ui/code-view-types'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'

export function buildCodeViewTreeDeleteRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('codeViewTreeDeleteRoute', {
    path: '/:owner/:repo/tree/delete/:branch/*',
    queries: [mainQuery<DataRouterDeletePagePayload>({encodeFetchPath: true})],
  })
}

export const codeViewTreeDeleteRoute = buildCodeViewTreeDeleteRoute(codeViewAppBuilder)
